<template>
  <AsideContainer>
    <template>
      <!-- 分享/收藏 -->
      <ArticleHeadMenu
        v-if="!isMobile"
        :articleID="artwork.id"
        :referenceType="1"
      />
      <!-- 類型 -->
      <FieldIdentitiy 
        v-if="!isMobile"
        :identity="artwork.identity"
      />
      <!-- 所在地點 -->
      <FieldRecommend
        linkPath="temple"
        :titleImage="{ src: 'house_new', alt: '所在地點', mode: 'thick' }"
        :fieldData="artwork.related_temples"
        :isRecommend="false"
      />
      <!-- 圖鑑集 -->
      <FieldAlbum
        linkPath="album"
        :titleImage="{ alt: '圖鑑集', mode: 'medium' }"
        :fieldData="artwork.related_albums"
      />
      <!-- 相關連結 -->
      <FieldOtherLinks
        :links="artwork.links"
        :titleImage="{
          src: 'title_other_link',
          alt: '相關連結',
          mode: 'medium',
          target: 'blank',
        }"
      />
      <!-- 推薦藝品 -->
      <FieldRecommend
        linkPath="artwork"
        :titleImage="{ alt: '推薦藝品', mode: 'thick' }"
        :fieldData="artwork.related_artworks"
      />
      <!-- 標籤 -->
      <FieldTags :tags="artwork.tags"/>

    </template>
  </AsideContainer>
</template>
<script>
import AsideContainer from './AsideContainer'
import ArticleHeadMenu from '../article/ArticleHeadMenu'
import FieldIdentitiy from './FieldIdentitiy'
import FieldAlbum from './FieldAlbum'
import FieldOtherLinks from './FieldOtherLinks'
import FieldRecommend from './FieldRecommend'
import FieldTags from './FieldTags'
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AsideContainer,
    ArticleHeadMenu,
    FieldIdentitiy,
    FieldAlbum,
    FieldOtherLinks,
    FieldRecommend,
    FieldTags
  },
  computed: {
    artwork() {
      return this.$store.getters.artwork;
    },
  }
}
</script>
